module.exports = __webpack_public_path__ + "media/assets/site_images/partner_logos/denutri_logo-3169d6ebf7a66c08d8c4d8077110e2c0.png";